import { Button, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CRM } from "../../../../services/API/CRM";
import Flex from "../../../Tools/Flex";
import Courses from "./Courses";
import Form from "./Form";

export default function Index({person}){

    const [courses, setCourses] = useState([])
    const [form, setForm] = useState(false)

    useEffect(() => {

        CRM.getTeacherCourses(person.id)
            .then(r => setCourses(r.data))
            .catch(e => console.log(e))

    }, [person])


    const handleSubmit = course => {

        let copy = [...courses];
        copy.push(course);
        
        CRM.postTeacherCourses(person.id, copy)
            .then(r => setCourses(r.data))
            .catch(e => console.log(e))

        return setForm(false);
    }

    const handleDelete = id => {

        let copy = [...courses];
        copy = copy.filter(c => c.id !== id)
        
        CRM.postTeacherCourses(person.id, copy)
            .then(r => setCourses(r.data))
            .catch(e => console.log(e))

        return setCourses(copy);
    }

    return <Stack spacing={2}>

        <Flex justifyContent='space-between' alignItems='center'>

            <Typography variant='h3'>Formateur</Typography>

            <Button variant='contained' onClick={() => setForm(true)}>
                Ajouter
            </Button>
            
        </Flex>

        <Courses items={courses} onDelete={id => handleDelete(id)} />

        <Form 
            open={form}
            onClose={() => setForm(false)}
            onSubmit={course => handleSubmit(course)}
        />

    </Stack>
}
